import {UserBrandingSetting} from '../../../domain/user-branding-setting';
import {
  IUserBrandingRepository
} from '../../../domain/user-branding-repository';
import {Router} from '@angular/router';
import {UI} from '../../../services/ui.service';
import {ToastrService} from 'ngx-toastr';

export class UserBrandingDashboardViewModel {
  public userBrandingSettings: UserBrandingSetting[] = [];

  constructor(
    private _userBrandingRepository: IUserBrandingRepository,
    private _router: Router,
    private _ui: UI,
    private _toastr: ToastrService,
    ) {
  }

  async onInit() {
    await this.reloadUserBrandingSettings();
  }

  async reloadUserBrandingSettings() {
    this.userBrandingSettings = await this._userBrandingRepository.getAll();
  }
  async onSettingsButtonClicked(chosenUserBrandingSetting: UserBrandingSetting) {
    await this._router.navigate(["/user-branding/edit", chosenUserBrandingSetting.domainNameAsUid]);
  }

  async onDeleteButtonClicked(chosenUserBrandingSetting: UserBrandingSetting) {
    if (chosenUserBrandingSetting.domainNameAsUid !== 'default') {
      this._ui.notify(this._ui.EVENTS.ShowConfirm, {
        title: "Delete Setting",
        message: `Are you sure that you want to delete ${chosenUserBrandingSetting.domainNameAsUid}?`,
        buttons: [
          {
            title: "Cancel",
            theme: "brigth",
            callback: () => {},
          },
          {
            title: "Remove",

            callback: async () => {
              await this._userBrandingRepository.delete(chosenUserBrandingSetting.domainNameAsUid);
              await this.reloadUserBrandingSettings();
            },
          },
        ],
      });

    }

  }

  async addNewSettingClicked() {
    const response = prompt('Specify Domain Name:').trim().toLowerCase();
    if (response && response.length > 0) {

      //checking uniqueness
      const allSettings = await this._userBrandingRepository.getAll();
      if (allSettings.find(s => s.domainNameAsUid.trim().toLowerCase() === response)) {
        this._toastr.error(`The domain name ${response} already exists!`);
      } else {
        //create a new setting
        //first find the default setting and override the domainNameAsUid
        const defaultSetting = allSettings.find(s => s.isDefault);
        const newSetting = defaultSetting;
        newSetting.domainNameAsUid = response;
        await this._userBrandingRepository.upsert(newSetting);

        //refresh the page
        await this.reloadUserBrandingSettings();
      }
    }
  }
}
